import React, { Component } from "react";
import parseHydraDocumentation from "@api-platform/api-doc-parser/lib/hydra/parseHydraDocumentation";
import { hydraClient, fetchHydra as baseFetchHydra } from "@api-platform/admin";
import authProvider from "./authProvider";
import { Route, Redirect } from "react-router-dom";
import Login from "./Login";
import Layout from "./Layout";
import Menu from "./Menu";
import englishMessages from "./i18n/en";
import "./App.css";
import loading from "./ekomi_logo_animation.gif";
import { Admin, Resource } from "react-admin";
import { createMuiTheme } from "@material-ui/core/styles";
import { CampaignList } from "./api-resource/campaign/List";
import { CampaignShow } from "./api-resource/campaign/Show";
import { CampaignEdit } from "./api-resource/campaign/Edit";
import { CampaignCreate } from "./api-resource/campaign/Create";
import customRoutes from "./customRoutes";
import { CouponList } from "./api-resource/coupon/List";
import { CouponShow } from "./api-resource/coupon/Show";
import { CouponEdit } from "./api-resource/coupon/Edit";
import { CouponCreate } from "./api-resource/coupon/Create";

const i18nProvider = locale => {
  if (locale === "fr") {
    // return import('./i18n/fr').then(messages => messages.default);
  }

  // Always fallback on english
  return englishMessages;
};

const theme = createMuiTheme({
  palette: {
    type: "light"
  }
});

const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;

const fetchHeaders = { "Authorization": `Bearer ${localStorage.getItem("token")}` };
const fetchHydra = (url, options = {}) => baseFetchHydra(url, {
  ...options,
  headers: new Headers(fetchHeaders)
});
const dataProvider = api => hydraClient(api, fetchHydra);

const apiDocumentationParser = entrypoint =>
  parseHydraDocumentation(entrypoint, {
    headers: new Headers(fetchHeaders)
  }).then(
    ({ api }) => ({ api }),
    result => {
      const { api, status } = result;

      if (status === undefined || status === 401 || status === 403) {
        return Promise.resolve({
          api,
          status,
          customRoutes: [
            <Route path="/" render={() => <Redirect to="/login"/>}/>
          ]
        });
      }
      return Promise.reject(result);
    }
  );

class App extends Component {
  state = { appIsLoading: false, api: null };

  componentDidMount() {
    apiDocumentationParser(entrypoint).then(({ api }) => {
      this.setState({ api });
    }).catch((e) => {
      console.log(e);
    });
  }

  static loadingAnimation() {
    return (
      <div style={
        {
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "white"
        }
      }>
        <img src={loading} alt="loading" style={
          {
            height: 200
          }
        }/>
      </div>
    );

  }

  render() {
    const { appIsLoading, api } = this.state;

    if (null === api || appIsLoading) {
      return App.loadingAnimation();
    }
    return (
      <Admin api={this.state.api}
             apiDocumentationParser={apiDocumentationParser}
             dataProvider={dataProvider(this.state.api)}
             theme={theme}
             appLayout={Layout}
             authProvider={authProvider}
             loginPage={Login}
             menu={Menu}
             locale="en"
             loading={App.loadingAnimation()}
             i18nProvider={i18nProvider}
             customRoutes={customRoutes}
      >
        <Resource name="campaigns" title="campaigns" list={CampaignList} show={CampaignShow} edit={CampaignEdit}
                  create={CampaignCreate}/>
        <Resource name="coupons" title="Coupons" list={CouponList} show={CouponShow} edit={CouponEdit}
                  create={CouponCreate}/>
      </Admin>
    );
  }
}

export default App;
